//#region src/file-upload.ts
var e = {
	"image/jpeg": "JPEG Image",
	"image/png": "PNG Image",
	"image/gif": "GIF Image",
	"image/webp": "WebP Image",
	"application/pdf": "PDF Document",
	"text/plain": "Plain Text",
	"text/markdown": "Markdown Document",
	"text/csv": "CSV File"
}, t = {
	MIN_SIZE: 1,
	MAX_SIZE: 10 * 1024 * 1024,
	IMAGE_MAX_SIZE: 5 * 1024 * 1024
}, n = {
	".md": "text/markdown",
	".pdf": "application/pdf",
	".txt": "text/plain",
	".csv": "text/csv"
}, r = new Set(["application/vnd.ms-excel"]);
function i(e) {
	let t = e.name.includes(".") ? e.name.slice(e.name.lastIndexOf(".")).toLowerCase() : "";
	return (e.type === "" || e.type === "application/octet-stream" || r.has(e.type)) && t && t in n ? n[t] : e.type;
}
function a(n) {
	if (n.size < t.MIN_SIZE) return "FILE_TOO_SMALL";
	let r = i(n);
	if (!(r in e)) return "UNSUPPORTED_TYPE";
	if (r.startsWith("image/")) {
		if (n.size > t.IMAGE_MAX_SIZE) return "IMAGE_TOO_LARGE";
	} else if (n.size > t.MAX_SIZE) return "FILE_TOO_LARGE";
	return null;
}
function o(e, t) {
	return t.some((t) => t.name === e.name && t.size === e.size && t.file.lastModified === e.lastModified);
}
async function s(e, t, n) {
	let r = new FormData();
	return Object.entries(t.signature.fields).forEach(([e, t]) => {
		r.append(e, t);
	}), r.append("file", e), new Promise((e, i) => {
		let a = new XMLHttpRequest();
		n && a.upload.addEventListener("progress", (e) => {
			e.lengthComputable && n(e.loaded / e.total * 100);
		}), a.addEventListener("load", () => {
			if (a.status >= 200 && a.status < 300) {
				let n = t.signature.fields.key;
				e(`${t.signature.url.endsWith("/") ? t.signature.url.slice(0, -1) : t.signature.url}${n.startsWith("/") ? n : `/${n}`}`);
			} else i(/* @__PURE__ */ Error(`Upload failed with status ${a.status}: ${a.responseText}`));
		}), a.addEventListener("error", () => {
			i(/* @__PURE__ */ Error("Network error during upload"));
		}), a.addEventListener("abort", () => {
			i(/* @__PURE__ */ Error("Upload was aborted"));
		}), a.open("POST", t.signature.url), a.send(r);
	});
}
function c(e, n) {
	let r = [], s = [], c = [], l = e.__uploadFiles.get();
	return n.forEach((e) => {
		if (o(e, l)) {
			c.push({
				name: e.name,
				reason: "File already selected"
			});
			return;
		}
		let n = a(e);
		if (n) {
			let r = "";
			switch (n) {
				case "UNSUPPORTED_TYPE":
					r = `File type ${i(e) || e.type || "unknown"} is not supported`;
					break;
				case "IMAGE_TOO_LARGE":
					r = `Image is too large (max ${t.IMAGE_MAX_SIZE / 1024 / 1024}MB)`;
					break;
				case "FILE_TOO_LARGE":
					r = `File is too large (max ${t.MAX_SIZE / 1024 / 1024}MB)`;
					break;
				case "FILE_TOO_SMALL":
					r = "File is too small";
					break;
				case "FILE_CORRUPTED":
					r = "File appears to be corrupted";
					break;
			}
			s.push({
				name: e.name,
				error: r
			});
			return;
		}
		let u = {
			id: crypto.randomUUID(),
			file: e,
			mimeType: i(e),
			size: e.size,
			name: e.name,
			status: "pending"
		};
		r.push(u);
	}), r.length > 0 && e.addUploadFiles(r), {
		addedCount: r.length,
		errors: s,
		skipped: c
	};
}
async function l(e, t) {
	if (e.id == null) await e.waitUntilReady();
	else if (e.isEnding || e.isEnded || e.status === "error") throw Error("Cannot upload file: session has ended");
	let n = e.__uploadFiles.get().find((e) => e.id === t);
	if (!n) throw Error(`File with ID ${t} not found`);
	try {
		e.updateUploadFile(t, {
			status: "uploading",
			uploadProgress: 0
		});
		let r = await e.getUploadSignature({
			size: n.size.toString(),
			mime_type: n.mimeType
		}), i = await s(n.file, r, (n) => {
			e.updateUploadFile(t, { uploadProgress: n });
		});
		return e.updateUploadFile(t, {
			status: "uploaded",
			uploadedUrl: i,
			uploadProgress: 100
		}), i;
	} catch (n) {
		let r = n instanceof Error ? n.message : "Upload failed";
		throw e.updateUploadFile(t, {
			status: "error",
			error: r
		}), n;
	}
}
async function u(e) {
	let t = e.__uploadFiles.get().filter((e) => e.status === "pending");
	if (t.length === 0) return {
		successful: [],
		failed: []
	};
	let n = await Promise.allSettled(t.map(async (t) => {
		try {
			let n = await l(e, t.id);
			return {
				id: t.id,
				name: t.name,
				mimeType: t.mimeType,
				uploadedUrl: n
			};
		} catch (e) {
			throw console.error(`Failed to upload file ${t.name}:`, e), e;
		}
	})), r = [], i = [];
	return n.forEach((n, a) => {
		let o = t[a];
		if (n.status === "fulfilled") r.push(n.value);
		else {
			let t = n.reason instanceof Error ? n.reason.message : "Upload failed";
			i.push({
				id: o.id,
				name: o.name,
				error: t
			}), e.removeUploadFile(o.id);
		}
	}), {
		successful: r,
		failed: i
	};
}
//#endregion
export { t as FILE_SIZE_LIMITS, e as SUPPORTED_FILE_TYPES, c as addCopilotFiles, o as fileAlreadyExists, i as resolveFileMimeType, u as uploadAllCopilotFiles, l as uploadCopilotFile, s as uploadToGCS, a as validateFile };
